import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';  //处理异步状态数据
import reducer from './reducer';


const store = createStore(reducer, applyMiddleware(thunk));
// const store = createStore(reducer, applyMiddleware(thunk.withExtraArgument(axios)));

export default store;
